export const DUPLICATE_CANONICAL_TARGET_LABEL = "Duplicate canonical target";
